export class APGCovid19Constants {
    static bioradLimsMechine: string = 'BioradLims';
    static flaABIMechine: string ='FLA-ABI';
    static splitCondition : string = "1*384 to 4*96";
    static LC480SubType: string ='LC 480 II';
    static fastFinder: string = 'Fast Finder';
    static positiveControlBarcode ='POS_EX';
    static samplePositiveResult ='positive';
    static bioradManufacturer = 'Bio-Rad';
    static terminatingStates: string[] = ['COMPLETED', 'REDO', 'REMOVED'];
}

export const colorMap = new Map();
colorMap.set('No Value', '#E88D8D');
colorMap.set('Good', '#8DBC7A');
colorMap.set('Low', '#FFFF40');
colorMap.set('High', '#4ea3d8');
